import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import * as moment from 'moment';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {Conquista, Graduacao} from '../tamas-models';

@Component({
  selector: 'app-perfil-item',
  templateUrl: './perfil-item.component.html',
  styleUrls: ['./perfil-item.component.css']
})
export class PerfilItemComponent implements OnInit {
  hideCL: boolean = false;
  titEdit: any = '';
  tipoDetalhe: any = '';
  valorDetalhe: any = '';
  perfilNomeUsuario: any = '';
  canDelete: boolean = false;
  dadosCq: Conquista = new Conquista();
  dadosGd: Graduacao = new Graduacao();
  urlFoto: any = '';
  txtTit: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.tipoDetalhe = this.route.snapshot.paramMap.get('itemlistar');
    this.perfilNomeUsuario = this.route.snapshot.paramMap.get('nomeusuario');
    this.valorDetalhe = this.route.snapshot.paramMap.get('iditem');

    if(this.perfilNomeUsuario == this.tmaService.hcNomeUsuario){
      this.canDelete = true;
    }
    this.carregarItem();
  }

  carregarItem() :void{
    if(this.tipoDetalhe == 'conquistas'){
      this.txtTit = 'Conquistas';
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idconquista=' + this.valorDetalhe + '&usuario=' + this.perfilNomeUsuario;
      this.tmaService.infoConquista(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        if(qRes['res'] == 'done'){
          this.dadosCq = qRes['meusDados'];
          //this.urlFoto =  "https://apptamas.melhorpedida.com/fotosusuarios/";
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-conquest/";
          console.log(this.dadosCq);
          this.dadosCq['DataRegistro'] = moment(this.dadosCq['DataRegistro']).format('DD/MM/YYYY');
        }
        this.hideCL = true;
      })
    }

    if(this.tipoDetalhe == 'titulos'){
      this.txtTit = 'Títulos';
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idtitulo=' + this.valorDetalhe + '&usuario=' + this.perfilNomeUsuario;
      this.tmaService.infoTitulo(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        if(qRes['res'] == 'done'){
          this.dadosGd = qRes['meusDados'];
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-academy/";
          console.log(this.dadosGd);
          //this.dadosCq['DataRegistro'] = moment(this.dadosCq['DataRegistro']).format('DD/MM/YYYY');
        }
        this.hideCL = true;
      })
    }
    
  }

  excluir() :void{

    const avisoIC =  this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {tituloAlerta: "Aviso",  textoAlerta: "Confirma a exclusão desta conquista?", textoCancel: "Não", textoConfirm: "Sim"}
    });
    avisoIC.afterClosed().subscribe((result) =>{
      console.log(result);
      if(result == true){
        this.hideCL = false;
        var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idconquista=' + this.valorDetalhe;
        this.tmaService.removerConquista(dadosIn)
        .subscribe((qRes) =>{
          console.log(qRes);
          this.hideCL = true;
          if(qRes['res'] == 'done'){
            this.voltar();
          }
        })
      }
    });
    
  }


  excluirg() :void{

    const avisoIC =  this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {tituloAlerta: "Aviso",  textoAlerta: "Confirma a exclusão desse título?", textoCancel: "Não", textoConfirm: "Sim"}
    });
    avisoIC.afterClosed().subscribe((result) =>{
      console.log(result);
      if(result == true){
        this.hideCL = false;
        var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idtitulo=' + this.valorDetalhe;
        this.tmaService.removerTitulo(dadosIn)
        .subscribe((qRes) =>{
          console.log(qRes);
          this.hideCL = true;
          if(qRes['res'] == 'done'){
            this.voltar();
          }
        })
      }
    });
    
  }
  voltar() :void{
    //this._location.back();
    this.router.navigate(['/' + this.perfilNomeUsuario + '/' + this.tipoDetalhe ]);
  }

}
